import { quote } from 'csx';

export const fontBody = 'Avenir Next';
export const fontHeading = 'Campton SemiBold';
export const fontIcons = 'hookd-icons';

export const fontDefault = `${quote(fontBody)}, 'Segoe UI', sans-serif`;
export const fontTitles = `${quote(fontHeading)}, ${quote(fontBody)}, 'Segoe UI', sans-serif`;
export const fontSerif = 'serif';
